module.exports = __webpack_public_path__ + "img/alb-dia.cd4b7c0d.jpg";